import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "@fce-bees/fce-common-components/styles.css";
import "./index.css";
import { asyncWithFbProvider } from "@featbit/react-client-sdk";

async function enableMocks() {
  if (import.meta.env.VITE_MOCKS_ENABLED === "true") {

    const { worker } = await import("./mocks/browser");
    const registration = await worker.start({ quiet: true });

    if (registration?.active) {
      console.log("Mock Service Worker: " + registration.active.state);
    }
  }
}

async function renderApp() {
  const rootElement = document.getElementById("root");

  if (!rootElement) {
    console.error("React mount point not found. An element with id 'root' must exist on the page.");
    return;
  }

  const featBitOptions = {
    options: {
      sdkKey: import.meta.env.VITE_REACT_APP_FEATBIT_SDK_KEY,
      streamingUri: import.meta.env.VITE_REACT_APP_FEATBIT_STREAMING_URL,
      eventsUri: import.meta.env.VITE_REACT_APP_FEATBIT_EVENT_URL,
      user: {
        name: "anonymous",
        keyId: "anonymous",
        customizedProperties: [],
      },
    },
  };
  const FeatBitProvider = await asyncWithFbProvider(featBitOptions);

  createRoot(rootElement).render(
    <StrictMode>
      <FeatBitProvider>
        <App />
      </FeatBitProvider>
    </StrictMode>
  );
}

async function bootstrap() {
  try {
    await enableMocks();
    await renderApp();
  } catch (err) {
    console.error("App bootstrap failed:", err);
  }
}

void bootstrap();
